import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { memo } from 'react';
import { Mm100Page } from '../..';
import DetailsModal from './DetailsModal';
import css from './index.module.scss';
import QuestionModal from './QuestionModal';
// import { powerPack, comboPack, solarPack, solarDiscountRate, defaultComboOptions, defaultPowerOptions, defaultSolarOptions, powerDetails, solarQuestion, comboPrice, bundleImgs } from './products'
import InfoCollection from '@/components/PowerKitPreSale/components/PreOrder/infocollection';
import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';
import SuccessDialog from '@/components/PowerKitPreSale/components/PreOrder/successDialog';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import PayPalIcon from '@/components/UI/svg/Icons/PayPalIcon';
// export const INSTALL_DES_COUNTRY = ['us']
export const INSTALL_DES_COUNTRY = [''];

export const InstallQuestionModal = ({ terms }: any) => {
    return (
        <div className="installQuestionModal">
            <p className="title">{terms?.title}</p>
            <p className="text">{terms?.text}</p>
            <p className="sup">{terms?.sup}</p>
        </div>
    );
};

function Child({ staticData, data, callBack }: any) {
    const { useLang, useState, useEffect, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const [hasCookieFooter, setHasCookieFooter] = useState(false);
    const [cookieFooterH, setCookieFooterH] = useState(0);
    const installSpecialSites = ['us', 'ca'];
    const activityIdMap: any = {
        us: '3',
        eu: '5',
        ca: '4',
        au: '11',
        uk: '6',
        kr: '10',
        de: '7',
        fr: '8',
        jp: '9',
        cn: '12',
        za: '13',
        it: '54',
        es: '53',
    };
    const [showInfoCollection, setShowInfoCollection] = useState(false);
    const [showInfoSuccess, setShowInfoSuccess] = useState(false);

    const {
        powerPack,
        comboPack,
        solarPack,
        solarDiscountRate,
        defaultComboOptions,
        defaultPowerOptions,
        defaultSolarOptions,
        powerDetails,
        solarQuestion,
        comboPrice,
        bundleImgs,
        installOptions,
        taxPriceTag,
        isPriveReverseFlag,
        installTerms,
    } = staticData;

    const [powerOptions, setPowerOptions] = useState(defaultPowerOptions);
    const [comboOptions, setComboOptions] = useState(comboPack);
    const [solarOptions, setSolarOptions] = useState(data?.solarOptions || solarPack);

    const [selectedPower, setSelectedPower] = useState(data?.selectedPower || null);
    const [selectedCombo, setSelectedCombo] = useState(data?.selectedCombo || null);
    // const [selectedSolar, setSelectedSolar] = useState(data?.selectedSolar || null)
    const [selectedInstall, setSelectedInstall] = useState(data?.selectedInstall || null);

    const imgArr = powerOptions[0]?.img?.split('/') || [];
    const mainImgData = imgArr.length ? imgArr[imgArr.length - 1] : '';
    const [mainImg, setMainImg] = useState(data?.bundle ? bundleImgs[data?.bundle] : mainImgData);
    const [bundle, setBundle] = useState(data?.bundle || null);

    const [totalDiscount, setTotalDiscount] = useState(data?.totalDiscount || 0);
    const [totalOriginal, setTotalOriginal] = useState(data?.totalOriginal || 0);

    const [detailsData, setDetailsData] = useState({} as any);
    const [detailsModalVisible, setDetailsModalVisible] = useState(false);
    const [questionData, setQuestionData] = useState({} as any);
    const [questionModalVisible, setQuestionModalVisible] = useState(false);

    const [installQuestionVisible, setInstallQuestionVisible] = useState(false);

    // generate powerOptions according to totalPower calculated in step 3
    useEffect(() => {
        if (data?.totalPower > 0 && data?.totalPower <= 2) {
            setPowerOptions([
                { ...powerPack['2'], tag: t('calculators.mm100.step4.recommended') },
                { ...powerPack['4'], tag: t('calculators.mm100.step4.deluxe') },
            ]);
        }
        if (data?.totalPower > 2 && data?.totalPower <= 4) {
            setPowerOptions([
                { ...powerPack['4'], tag: t('calculators.mm100.step4.recommended') },
                { ...powerPack['5'], tag: t('calculators.mm100.step4.deluxe') },
                { ...powerPack['2'], tag: t('calculators.mm100.step4.regular') },
            ]);
        }
        if (data?.totalPower > 4 && data?.totalPower <= 5) {
            setPowerOptions([
                { ...powerPack['5'], tag: t('calculators.mm100.step4.recommended') },
                { ...powerPack['10'], tag: t('calculators.mm100.step4.deluxe') },
                { ...powerPack['4'], tag: t('calculators.mm100.step4.regular') },
            ]);
        }
        if (data?.totalPower > 5 && data?.totalPower <= 10) {
            setPowerOptions([
                { ...powerPack['10'], tag: t('calculators.mm100.step4.recommended') },
                { ...powerPack['15'], tag: t('calculators.mm100.step4.deluxe') },
                { ...powerPack['5'], tag: t('calculators.mm100.step4.regular') },
            ]);
        }
        if (data?.totalPower > 10 && data?.totalPower <= 15) {
            setPowerOptions([
                { ...powerPack['15'], tag: t('calculators.mm100.step4.recommended') },
                { ...powerPack['10'], tag: t('calculators.mm100.step4.regular') },
            ]);
        }
        if (data?.totalPower > 15) {
            setPowerOptions([{ ...powerPack['15'], tag: t('calculators.mm100.step4.recommended') }]);
        }
    }, [data?.totalPower]);

    useEffect(() => {
        const imgArr = powerOptions[0]?.img?.split('/') || [];
        const mainImgData = imgArr.length ? imgArr[imgArr.length - 1] : '';
        setMainImg(data?.bundle ? bundleImgs[data?.bundle] : mainImgData);
    }, [powerOptions]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setHasCookieFooter(entry.isIntersecting);
                },
                { threshold: 0.5 },
            );

            const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
            if (kaamelAlertBigNew) {
                observer.observe(kaamelAlertBigNew);
            }

            return () => {
                observer.disconnect();
            };
        }
    }, []);

    useEffect(() => {
        const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
        setCookieFooterH(hasCookieFooter ? kaamelAlertBigNew?.offsetHeight : 0);
    }, [hasCookieFooter]);

    useEffect(() => {
        if (bundle) {
            setMainImg(bundleImgs[bundle]);
        }
    }, [bundle]);

    const handleSelectPower = (item: any) => {
        const comboEl = document.querySelector('.comboBox') as HTMLElement;
        window.scrollTo({
            top: comboEl?.offsetTop - 105 || 1506 - 105,
            behavior: 'smooth',
        });
        setSelectedPower(item);
        setBundle(item?.variantId[selectedCombo?.productId || 0]);
        callBack({
            currentStep: data?.stepTitle?.length - (data?.selectedCombo ? 2 : 3),
            selectedPower: item,
            bundle: item?.variantId[selectedCombo?.productId],
        });
    };

    const handleSelectCombo = (item: any) => {
        if (selectedPower && selectedPower?.productId) {
            const targetEl = document.querySelector(installSpecialSites.includes(locale) ? '.solarBox ' : '.installBox') as HTMLElement;
            if (targetEl) {
                window.scrollTo({
                    top: targetEl?.offsetTop - 105 || 2370 - 105,
                    behavior: 'smooth',
                });
            } else {
                const solarEl = document.querySelector('.solarBox') as HTMLElement;
                window.scrollTo({
                    top: solarEl?.offsetTop - 105 || 2808 - 105,
                    behavior: 'smooth',
                });
            }
            setSelectedCombo(item);
            setBundle(selectedPower?.variantId[item?.productId]);
            callBack({
                currentStep: data?.stepTitle?.length - 2,
                selectedCombo: item,
                bundle: selectedPower?.variantId[item?.productId],
                currentPage: data?.currentPage > Mm100Page.SolarPanel ? Mm100Page.Result : Mm100Page.SolarPanel,
            });
        }
    };

    // const handleSelectSolar = (item: any) => {
    //     if (selectedCombo && selectedCombo?.productId >= 0) {
    //         setSelectedSolar(item)
    //         callBack({ currentStep: data?.stepTitle?.length - 1, selectedSolar: item })
    //     }
    // }

    const handleSelectInstall = (item: any, text: string) => {
        if (installSpecialSites.includes(locale)) {
            const powerEl = document.querySelector('.powerOptions') as HTMLElement;
            window.scrollTo({
                top: powerEl?.offsetTop - 105 || 2696 - 105,
                behavior: 'smooth',
            });
            setSelectedInstall({ ...item, text });
            callBack({
                selectedInstall: { ...item, text },
            });
        } else {
            const solarEl = document.querySelector('.solarBox') as HTMLElement;
            window.scrollTo({
                top: solarEl?.offsetTop - 105 || 2696 - 105,
                behavior: 'smooth',
            });
            if (selectedPower && selectedCombo) {
                setSelectedInstall({ ...item, text });
                callBack({
                    selectedInstall: { ...item, text },
                });
            }
        }
    };

    // useEffect(() => {
    //     if (selectedPower) {
    //         const newSolarOptions = [...solarOptions]
    //         newSolarOptions?.map((item: any) =>
    //             item.discountRate = solarDiscountRate[selectedPower?.productId][selectedCombo ? String(selectedCombo.productId) : '0'] || 1
    //         )
    //         setSolarOptions(newSolarOptions)
    //     }
    // }, [selectedPower, selectedCombo])

    const goDetails = (e: any, details: any) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
        setDetailsData(details);
        // setDetailsData(defaultDetailData)
        setDetailsModalVisible(true);
    };

    const goQuestion = (e: any, question: any) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
        setQuestionData(question);
        // setQuestionData(defaultQuestionData)
        setQuestionModalVisible(true);
    };

    const handleCheckout = () => {
        if (!selectedPower || !selectedCombo) {
            return;
        }
        if (installOptions && !selectedInstall) {
            const installEl = document.querySelector('.calculatorMm100 .step456 .installBox') as HTMLElement;
            return window.scrollTo({
                top: installEl?.offsetTop - 105,
                behavior: 'smooth',
            });
        }
        const optionName = selectedPower.name;
        const comboName = selectedCombo.name || 'No,Thanks';
        const addOnArr: any = [];
        solarOptions.forEach((item: any) => {
            if (item.number > 0) {
                addOnArr.push(item.name);
                addOnArr.push(item.number);
            }
            return '';
        });
        const addOnName = addOnArr.length > 0 ? addOnArr.join('_') : '';
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator4',
            step: 'capacity',
            product_name: 'EcoFlow Power Kits',
            option_name: optionName || '',
            combo: comboName,
            add_on: addOnName,
            type: selectedInstall?.text || 'none',
            price: (powerOptions[0]?.unit || '') + totalDiscount,
            button_name: 'Checkout',
        });

        callBack({
            currentStep: data?.stepTitle?.length,
            currentPage: Mm100Page.Result,
            totalDiscount,
            totalOriginal,
            selectedPower,
            selectedCombo,
            // selectedSolar,
            selectedInstall,
            solarOptions,
            bundle,
        });
    };

    const handleCount = (solar: any, number: number) => {
        // if (selectedSolar?.productId === solar?.productId) {
        //     setSelectedSolar({ ...solar, number })
        // }
        const targetSolarIndex = solarOptions?.findIndex((item: any) => item?.variantId === solar?.variantId);
        const newSolarOptions = [...solarOptions.slice(0, targetSolarIndex), { ...solar, number }, ...solarOptions.slice(targetSolarIndex + 1)];
        setSolarOptions(newSolarOptions);
    };

    useEffect(() => {
        callBack({
            currentStep: solarOptions?.some((solar: any) => solar?.number > 0)
                ? data?.stepTitle?.length - 1
                : selectedCombo
                ? data?.stepTitle?.length - 2
                : data?.stepTitle?.length - 3,
        });
    }, [solarOptions]);

    useEffect(() => {
        if (selectedPower && comboPrice) {
            let totalSolarPrice = 0;
            solarOptions?.map((solar: any, k: number) => {
                totalSolarPrice += Math.round(solar?.number * (100 * solar?.originalPrice)) / 100;
            });
            setTotalDiscount(selectedPower?.discountPrice + (comboPrice[selectedPower?.productId]?.discount[selectedCombo?.productId] ?? 0) + totalSolarPrice);
            setTotalOriginal(selectedPower?.originalPrice + (comboPrice[selectedPower?.productId]?.original[selectedCombo?.productId] ?? 0) + totalSolarPrice);
        }
    }, [selectedPower, selectedCombo, solarOptions, comboPrice]);

    const CommonChecked = () => (
        <div className="checkedIcon">
            <Image
                src="/img/calculators/mm100/selected.svg"
                layout="fill"
                className="fullImgs"
                alt={t('calculators.mm100.checked')}
                aria-label={t('calculators.mm100.checked')}
            />
        </div>
    );

    const AddSubtractor = ({ data, callBack }: any) => {
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.number ?? 0);

        const reduceNumber = (e: any) => {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            } else {
                window.event.cancelBubble = true;
            }
            if (number <= 0) return false;
            setNumber(number - 1);
            callBack(data, number - 1);
        };

        const addNumber = (e: any) => {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            } else {
                window.event.cancelBubble = true;
            }
            if (number >= 99) return false;
            setNumber(number + 1);
            callBack(data, number + 1);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= 0 ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                <div className="addSubtractor-number">{number}</div>
                <div className={number >= 99 ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setShowInfoCollection(false);
            setShowInfoSuccess(true);
        }
        switch (status) {
            case 'success':
                setShowInfoCollection(false);
                setShowInfoSuccess(true);
                break;
            case 'close':
                setShowInfoCollection(false);
                break;
        }
    };

    const openQoute = () => {
        if (['us', 'ca'].includes(locale)) toMM100GetQuote(locale);
        else setShowInfoCollection(true);
    };

    return (
        <div className={`step456 step ${css.step456}`}>
            {/* left main img */}
            <div className="leftMainImg">
                <Image
                    src={`/img/calculators/mm100/${mainImg}`}
                    layout="fill"
                    className="fullImgs"
                    alt={selectedPower?.productName || powerOptions[0]?.productName}
                    aria-label={selectedPower?.productName || powerOptions[0]?.productName}
                />
            </div>
            {/* right info */}
            <div className="rightSliderBox">
                {/* power kits */}
                <div className="powerBox">
                    <h2 className="powerTitle commonTitle">{t('calculators.mm100.step4.subTitle1')}</h2>
                    <p className="powerConsumption">
                        {t.rich('calculators.mm100.step4.alert', {
                            bold: (children: any) => <span className="bold">{children}</span>,
                            totalPower: Math.round(100 * data?.totalPower) / 100 || 0,
                        })}
                    </p>
                    {/* installation */}
                    {installOptions && installSpecialSites.includes(locale) && (
                        <div className={`installBox`}>
                            <h3 className="installTitle commonTitle">
                                {t('calculators.mm100.step4.installation')}
                                <span className="red">*</span>
                            </h3>
                            <ul className="installOptions">
                                {installOptions?.map((install: any, k: number) => (
                                    <li
                                        className={`install-item ${selectedInstall?.variantId === install?.variantId ? 'active' : ''}`}
                                        key={k}
                                        onClick={() => handleSelectInstall(install, t(`calculators.mm100.step4.${install?.i18n}`))}
                                    >
                                        <p className="install-text">{t(`calculators.mm100.step4.${install?.i18n}`)}</p>
                                        <p className="install-des">
                                            {t.rich(`calculators.mm100.step4.${install?.i18n_des}`, {
                                                line: (text: string) => (
                                                    <Link href="/support/videos" className="install-link" newWin>
                                                        {text}
                                                    </Link>
                                                ),
                                            })}
                                        </p>
                                        {install?.i18n_des && (
                                            <div className="install-desc">
                                                {t(`calculators.mm100.step4.${install?.i18n_des}`)}
                                                {INSTALL_DES_COUNTRY.includes(locale) && (
                                                    <span
                                                        className="question"
                                                        onMouseEnter={() => setInstallQuestionVisible(true)}
                                                        onMouseLeave={() => setInstallQuestionVisible(false)}
                                                    >
                                                        <Image
                                                            src={'/img/calculators/mm100/question-mark.svg'}
                                                            layout="fill"
                                                            className="fullImgs"
                                                            alt={t('calculators.mm100.step4.questionMark')}
                                                            aria-label={t('calculators.mm100.step4.questionMark')}
                                                        />
                                                        {installQuestionVisible && (
                                                            <div className="installModal">
                                                                <InstallQuestionModal terms={installTerms} />
                                                            </div>
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                        {CommonChecked()}
                                    </li>
                                ))}
                            </ul>
                            <div className="quoteBox">
                                {t.rich('calculators.mm100.step4.quote', {
                                    line: (text: string) => (
                                        <span className="quoteLink" onClick={() => openQoute()}>
                                            {text}
                                        </span>
                                    ),
                                })}
                                {locale === 'us' && (
                                    <Link className="quoteLink" href="/where-to-buy">
                                        {t('calculators.mm100.step4.nearby')}
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                    <ul className={`powerOptions ${installSpecialSites.includes(locale) && installOptions && !selectedInstall ? 'disable' : ''}`}>
                        {powerOptions?.map((power: any, k: number) => (
                            <li
                                className={`power-item item-box ${selectedPower?.productId === power?.productId ? 'active' : ''}`}
                                key={k}
                                onClick={() => handleSelectPower(power)}
                            >
                                <div className="topHalf">
                                    <p className="power-item-tagUsage">
                                        <span className="tag">{power?.tag}</span>
                                        <span className="usage">{t('calculators.mm100.step4.daily')}</span>
                                    </p>
                                    <p className="power-item-name item-name">
                                        <span className="name">{power?.name}</span>
                                        <span className="days">
                                            {Math.round((power?.capacity * 10) / data?.totalPower) / 10}{' '}
                                            {Math.round((power?.capacity * 10) / data?.totalPower) / 10 === 1
                                                ? t('calculators.mm100.step4.day')
                                                : t('calculators.mm100.step4.days')}
                                        </span>
                                    </p>
                                    {locale !== 'cn' && (
                                        <p className="power-item-price item-price">
                                            <span className="discount">
                                                {!isPriveReverseFlag && `${power?.unit} `}
                                                {FormatMoney(power?.discountPrice, isPriveReverseFlag ? ' ' : ',')}
                                                {isPriveReverseFlag && ` ${power?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                            {power?.discountPrice !== power?.originalPrice && (
                                                <span className="original">
                                                    {!isPriveReverseFlag && `${power?.unit} `}
                                                    {FormatMoney(power?.originalPrice, isPriveReverseFlag ? ' ' : ',')}
                                                    {isPriveReverseFlag && ` ${power?.unit}`}
                                                    {taxPriceTag[locale] || ''}
                                                </span>
                                            )}
                                        </p>
                                    )}
                                    {locale === 'cn' && (
                                        <p className="power-item-price item-price">
                                            <span className="discount">{t('calculators.mm100.step4.inquiry')}</span>
                                        </p>
                                    )}
                                    {power?.discountPrice !== power?.originalPrice && locale !== 'cn' && (
                                        <span className="power-item-priceTag item-priceTag">
                                            {t('calculators.mm100.step4.save')}
                                            {!isPriveReverseFlag && `${power?.unit} `}
                                            {FormatMoney(
                                                Math.round(100 * power?.originalPrice - 100 * power?.discountPrice) / 100,
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${power?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </span>
                                    )}
                                </div>
                                <div className="bottomHalf">
                                    <p className="includes">{t('calculators.mm100.step4.includes')}</p>
                                    <ul className="includes-items">
                                        <li className="power-include-item">
                                            {power?.includes?.map((include: any, m: number) => (
                                                <span className="power-include" key={m}>
                                                    {include} <span className="plus">+</span>{' '}
                                                </span>
                                            ))}
                                        </li>
                                    </ul>
                                    <div className="details" onClick={(e: any) => goDetails(e, { ...powerDetails, img: power?.detailImg })}>
                                        {t('calculators.mm100.step4.detail')}
                                        <span className="trangle"></span>
                                    </div>
                                </div>
                                {CommonChecked()}
                            </li>
                        ))}
                    </ul>
                    <p className="powerTip">{t('calculators.mm100.step4.tip')}</p>
                </div>
                {/* combo */}
                <div className={`comboBox ${!selectedPower ? 'disable' : ''}`}>
                    <h3 className="comboTitle commonTitle">{t('calculators.mm100.step4.subTitle2')}</h3>
                    <ul className="comboOptions">
                        {comboOptions?.map((combo: any, k: number) => (
                            <li
                                className={`combo-item item-box ${selectedCombo?.productId === combo?.productId ? 'active' : ''}`}
                                key={k}
                                onClick={() => handleSelectCombo(combo)}
                            >
                                <div className="topHalf">
                                    <p className="combo-item-name item-name">{combo?.name}</p>
                                    {locale !== 'cn' && (
                                        <p className="combo-item-price item-price">
                                            <span className="discount">
                                                {!isPriveReverseFlag && `${combo?.unit} `}
                                                {FormatMoney(
                                                    comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.discount[
                                                        combo?.productId
                                                    ],
                                                    isPriveReverseFlag ? ' ' : ',',
                                                )}
                                                {isPriveReverseFlag && ` ${combo?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                            {comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.discount[combo?.productId] !==
                                                comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.original[
                                                    combo?.productId
                                                ] && (
                                                <span className="original">
                                                    {!isPriveReverseFlag && `${combo?.unit} `}
                                                    {FormatMoney(
                                                        comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.original[
                                                            combo?.productId
                                                        ],
                                                        isPriveReverseFlag ? ' ' : ',',
                                                    )}
                                                    {isPriveReverseFlag && ` ${combo?.unit}`}
                                                    {taxPriceTag[locale] || ''}
                                                </span>
                                            )}
                                        </p>
                                    )}
                                    {locale === 'cn' && (
                                        <p className="combo-item-price item-price">
                                            <span className="discount">{t('calculators.mm100.step4.inquiry')}</span>
                                        </p>
                                    )}
                                    {comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.discount[combo?.productId] !==
                                        comboPrice[selectedPower ? selectedPower?.productId : powerOptions[0]?.productId]?.original[combo?.productId] &&
                                        locale !== 'cn' && (
                                            <span className="combo-item-priceTag item-priceTag">
                                                {t('calculators.mm100.step4.save')}
                                                {!isPriveReverseFlag && `${combo?.unit} `}
                                                {FormatMoney(
                                                    Math.round(
                                                        100 * comboPrice[selectedPower?.productId || powerOptions[0]?.productId]?.original[combo?.productId] -
                                                            100 *
                                                                comboPrice[selectedPower?.productId || powerOptions[0]?.productId]?.discount[combo?.productId],
                                                    ) / 100,
                                                    isPriveReverseFlag ? ' ' : ',',
                                                )}
                                                {isPriveReverseFlag && ` ${combo?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                        )}
                                </div>
                                <div className="bottomHalf">
                                    <ul className="combo-subs">
                                        {combo?.subs?.map((sub: any, m: number) => (
                                            <li className="combo-subs-item" key={m}>
                                                <div className="combo-subs-item-img">
                                                    <Image src={sub?.img} layout="fill" className="fullImgs" alt={sub?.name} aria-label={sub?.name} />
                                                </div>
                                                <h4 className="combo-subs-item-title">{sub?.name}</h4>
                                                {!sub?.details && <p className="combo-subs-item-desc">{sub?.desc}</p>}
                                                {sub?.details && (
                                                    <div className="details" onClick={(e: any) => goDetails(e, sub?.details)}>
                                                        {t('calculators.mm100.step4.detail')}
                                                        <span className="trangle"></span>
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {CommonChecked()}
                            </li>
                        ))}
                    </ul>
                    <div className={`no-combo ${selectedCombo?.productId === 0 ? 'active' : ''}`} onClick={() => handleSelectCombo({ productId: 0 })}>
                        {t('calculators.mm100.step4.no_thanks')}
                        {CommonChecked()}
                    </div>
                </div>
                {/* installation */}
                {installOptions && !installSpecialSites.includes(locale) && (
                    <div className={`installBox ${!selectedPower || !selectedCombo ? 'disable' : ''}`}>
                        <h3 className="installTitle commonTitle">
                            {t('calculators.mm100.step4.installation')}
                            <span className="red">*</span>
                        </h3>
                        <ul className="installOptions">
                            {installOptions?.map((install: any, k: number) => (
                                <li
                                    className={`install-item ${selectedInstall?.variantId === install?.variantId ? 'active' : ''}`}
                                    key={k}
                                    onClick={() => handleSelectInstall(install, t(`calculators.mm100.step4.${install?.i18n}`))}
                                >
                                    <p className="install-text">{t(`calculators.mm100.step4.${install?.i18n}`)}</p>
                                    {install?.i18n_des && (
                                        <div className="install-desc">
                                            {locale !== 'us' && t(`calculators.mm100.step4.${install?.i18n_des}`)}
                                            {INSTALL_DES_COUNTRY.includes(locale) && (
                                                <span
                                                    className="question"
                                                    onMouseEnter={() => setInstallQuestionVisible(true)}
                                                    onMouseLeave={() => setInstallQuestionVisible(false)}
                                                >
                                                    <Image
                                                        src={'/img/calculators/mm100/question-mark.svg'}
                                                        layout="fill"
                                                        className="fullImgs"
                                                        alt={t('calculators.mm100.step4.questionMark')}
                                                        aria-label={t('calculators.mm100.step4.questionMark')}
                                                    />
                                                    {installQuestionVisible && (
                                                        <div className="installModal">
                                                            <InstallQuestionModal terms={installTerms} />
                                                        </div>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {CommonChecked()}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {/* solar panel */}
                <div className={`solarBox ${!selectedPower || !selectedCombo || (installOptions && !selectedInstall) ? 'disable' : ''}`}>
                    <h3 className="solarTitle commonTitle">
                        {t('calculators.mm100.step4.subTitle3')}
                        {locale === 'us' && (
                            <Link href="https://blog.ecoflow.com/us/guide-to-the-federal-solar-tax-credit/" newWin>
                                Learn More
                                <span className="arrow-icon">
                                    <EFArrowLeft />
                                </span>
                            </Link>
                        )}
                    </h3>
                    {locale !== 'us' && <h3 className="solarSubTitle commonTitle">{t('calculators.mm100.step4.subTitle4')}</h3>}
                    <ul className="solarOptions">
                        {solarOptions?.map((solar: any, k: number) => (
                            <li
                                className={`solar-item item-box ${solar?.number > 0 ? 'active' : ''}`}
                                key={k}
                                style={{
                                    display: !solar?.locale || solar?.locale?.includes(locale) ? '' : 'none',
                                }}
                            >
                                <div className="topHalf">
                                    <div className="solar-item-img">
                                        <Image src={solar?.img} layout="fill" className="fullImgs" alt={solar?.name} aria-label={solar?.name} />
                                    </div>
                                    <p className="solar-item-name item-name">{solar?.name}</p>
                                    {locale !== 'cn' && (
                                        <p className="solar-item-price item-price">
                                            <span className="discount">
                                                {!isPriveReverseFlag && `${solar?.unit} `}
                                                {FormatMoney(solar?.discountPrice, isPriveReverseFlag ? ' ' : ',')}
                                                {isPriveReverseFlag && ` ${solar?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                            {solar?.originalPrice !== solar?.discountPrice && (
                                                <span className="original">
                                                    {!isPriveReverseFlag && `${solar?.unit} `}
                                                    {FormatMoney(solar?.originalPrice, isPriveReverseFlag ? ' ' : ',')}
                                                    {isPriveReverseFlag && ` ${solar?.unit}`}
                                                    {taxPriceTag[locale] || ''}
                                                </span>
                                            )}
                                        </p>
                                    )}
                                    {locale === 'cn' && (
                                        <p className="solar-item-price item-price">
                                            <span className="discount">{t('calculators.mm100.step4.inquiry')}</span>
                                        </p>
                                    )}
                                    {solar?.originalPrice !== solar?.discountPrice && (
                                        <span className="solar-item-priceTag item-priceTag">
                                            {t('calculators.mm100.step4.save')} {!isPriveReverseFlag && `${solar?.unit} `}
                                            {FormatMoney(
                                                Math.round(100 * solar?.originalPrice - 100 * solar?.discountPrice) / 100,
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${solar?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </span>
                                    )}
                                    {solar?.freeShip === 1 && <div className="solar-free-ship">{t('calculators.mm100.step4.free_shiping')}</div>}
                                    <div className="solar-item-controls">
                                        <div className="left-aria">
                                            <div className="upArrow">
                                                <Image
                                                    src={'/img/calculators/mm100/up-arrow.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.upArrow')}
                                                    aria-label={t('calculators.mm100.step4.upArrow')}
                                                />
                                            </div>
                                            <span className="hours">
                                                {Math.round((10 * solar?.capacity * 0.8 * 5 * solar?.number) / data?.totalPower / 1000) / 10}{' '}
                                                {t('calculators.mm100.step4.hrs')}
                                            </span>
                                            <div className="questionMark" onClick={(e: any) => goQuestion(e, solarQuestion)}>
                                                <Image
                                                    src={'/img/calculators/mm100/question-mark.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.questionMark')}
                                                    aria-label={t('calculators.mm100.step4.questionMark')}
                                                />
                                            </div>
                                        </div>
                                        <div className="right-aria">
                                            <AddSubtractor data={solar} callBack={handleCount} />
                                        </div>
                                    </div>
                                </div>
                                <div className="bottomHalf">
                                    {/* <p className="solar-item-desc">{solar?.desc}</p> */}
                                    <div className="details" onClick={(e: any) => goDetails(e, solar?.details)}>
                                        {t('calculators.mm100.step4.detail')}
                                        <span className="trangle"></span>
                                    </div>
                                </div>
                                {/* {CommonChecked()} */}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {/* checkout footer */}
            <div className="fixedFooter" style={{ bottom: `${cookieFooterH}px` }}>
                <div className="container">
                    {locale === 'us' && (
                        <div className="paypal">
                            <p className="icon">
                                <PayPalIcon />
                            </p>
                            <p className="desc-tips">
                                <span className="text">Buy now, pay later</span>
                                <Link href="https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later">
                                    Learn More
                                    <span className="arrow-icon">
                                        <EFArrowLeft />
                                    </span>
                                </Link>
                            </p>
                        </div>
                    )}
                    <div className="right">
                        {locale !== 'cn' && (
                            <div className="footer-price">
                                <p className="price">
                                    <span className="total-discount">
                                        {!isPriveReverseFlag && `${powerOptions[0]?.unit} `}
                                        {FormatMoney(Math.round(100 * totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                        {isPriveReverseFlag && ` ${powerOptions[0]?.unit}`}
                                        {taxPriceTag[locale] || ''}
                                    </span>
                                    {Math.round(100 * totalDiscount) !== Math.round(100 * totalOriginal) && (
                                        <span className="total-original">
                                            {!isPriveReverseFlag && `${powerOptions[0]?.unit} `}
                                            {FormatMoney(Math.round(100 * totalOriginal) / 100, isPriveReverseFlag ? ' ' : ',')}
                                            {isPriveReverseFlag && ` ${powerOptions[0]?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </span>
                                    )}
                                </p>
                                {Math.round(100 * totalDiscount) !== Math.round(100 * totalOriginal) && (
                                    <span className="total-price-tag">
                                        {t('calculators.mm100.step4.save')}
                                        {!isPriveReverseFlag && `${powerOptions[0]?.unit} `}
                                        {FormatMoney(Math.round(100 * totalOriginal - 100 * totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                        {isPriveReverseFlag && ` ${powerOptions[0]?.unit}`}
                                        {taxPriceTag[locale] || ''}
                                    </span>
                                )}
                            </div>
                        )}
                        {locale == 'cn' && (
                            <div className="footer-price">
                                <p className="price">
                                    <span className="total-discount">{t('calculators.mm100.step4.inquiry')}</span>
                                </p>
                            </div>
                        )}
                        <span
                            className={`footer-checkout ${!selectedPower || !selectedCombo || (installOptions && !selectedInstall) ? 'disable' : ''}`}
                            onClick={handleCheckout}
                            // disabled={!selectedPower || !selectedCombo || !selectedInstall}
                            aria-label={t('calculators.mm100.step4.checkoutBtn')}
                        >
                            {t('calculators.mm100.step4.checkoutBtn')}
                        </span>
                    </div>
                </div>
            </div>
            {/* detail modal */}
            <DetailsModal data={detailsData} isShow={detailsModalVisible} callBack={() => setDetailsModalVisible(false)} />
            {/* question modal */}
            <QuestionModal data={questionData} isShow={questionModalVisible} callBack={() => setQuestionModalVisible(false)} />
            {installSpecialSites.includes(locale) && (
                <>
                    {showInfoCollection && <InfoCollection cbFunc={collectInfoCb} isCalculator={true} activityId={activityIdMap[locale] || activityIdMap.us} />}
                    {showInfoSuccess && <SuccessDialog isCalculator={true} closeSuccDialog={() => setShowInfoSuccess(false)} />}
                </>
            )}
        </div>
    );
}

const MemoDom = memo(Child);
export default function Step456({ data, callBack }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const staticData = require(`@/data/calculators/mm100/${locale || 'us'}`);
    return <MemoDom staticData={staticData()} data={data} callBack={callBack} />;
}
